import React from 'react';

// Double chevrons for the toggle chip: up = set to 100%, down = set to 0%.
const DoubleChevronIcon = ({ direction }) => (
  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d={direction === 'up' ? 'M5 11l7-7 7 7M5 19l7-7 7 7' : 'M19 13l-7 7-7-7M19 5l-7 7-7-7'}
    />
  </svg>
);

// Grant split percentage for one grant column, with a one-click toggle chip:
// when the grant isn't at 100% the chip shows a double up arrow and moves the whole
// row to this grant (every other grant to 0%, so the row totals 100%); when it
// already is, the chip shows a double down arrow and clears it. Double-clicking
// the box does the same.
// Saves happen through onChange with the whole updated split.
const PaymentPercentInput = ({ grant, payment = {}, grants = [], onChange, disabled = false, inputKey }) => {
  const value = payment[grant] || '0';
  const isFull = parseFloat(value) === 100;

  const toggle = () => {
    if (disabled) return;
    const next = { ...payment };
    if (isFull) {
      next[grant] = '0';
    } else {
      grants.forEach((g) => { next[g] = '0'; });
      next[grant] = '100';
    }
    onChange(next);
  };

  return (
    <div className="inline-flex items-stretch">
      <input
        key={inputKey || `${grant}-${value}`}
        type="number"
        className="w-12 text-xs text-center border border-gray-300 rounded-l px-1 py-0.5 focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
        defaultValue={value}
        onBlur={(e) => {
          if (e.target.value !== value) onChange({ ...payment, [grant]: e.target.value });
        }}
        onDoubleClick={toggle}
        disabled={disabled}
        title="Double-click to toggle 100% / 0%"
      />
      <button
        type="button"
        onClick={toggle}
        disabled={disabled}
        title={isFull ? 'Set to 0%' : 'Set to 100% (other grants to 0%)'}
        aria-label={isFull ? 'Set to 0%' : 'Set to 100%'}
        className={`min-w-[30px] px-1 inline-flex items-center justify-center border border-l-0 rounded-r transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${
          isFull
            ? 'bg-gray-100 text-gray-600 border-gray-300 hover:bg-gray-200'
            : 'bg-primary-50 text-primary-700 border-primary-200 hover:bg-primary-100'
        }`}
      >
        <DoubleChevronIcon direction={isFull ? 'down' : 'up'} />
      </button>
    </div>
  );
};

export default PaymentPercentInput;
